module.exports = __webpack_public_path__ + "img/6.9f59ea9d.png";